<template>
    <div>
        <section class="error_wrapper">
        <div class="page-container">
            <h1 class="eyebrow-page">
                <span class="fw-semibold omnes">Oops! We can’t find the page you’re looking for!</span>
            </h1>

            <div class="text-wrapper">
                <p class="fw-bold">
                    Below are some helpful links that you may want to check out
                    instead.
                </p>
            </div>
        </div>

        <SitemapLinks />
    </section>
    <div class="blue-line">
        
    </div>
    </div>
</template>

<script>
import SitemapLinks from '../components/Sitemap-links.vue';

export default {
    components: {
        SitemapLinks,
    },
    methods: {
        openSubmenu(e) {
            let opener = e.target;
            if (opener.nextElementSibling.classList.contains('open')) {
                opener.nextElementSibling.classList.remove('open');
            } else {
                opener.nextElementSibling.classList.add('open');
            }
        },
    },
};
</script>
